import React from "react";
import { ILinkFunc } from "../../lib/util";
import { Button } from "../Button";
import Heading from "./Heading";
import Slider from "react-slick";
import { Settings } from "react-slick";
import { BackgroundImage } from "../Media";
import { IMediaItem } from "../../lib";


export interface ILabeledCard {
    classNames?: string;
    image?: IMediaItem;
    link?: { href: string; text: string; target?: string; }
    key?: number;
}

export interface ILabeledImageCardCarouselProps {
    classNames?: string;
    title?: string;
    titleClassNames?: string;
    titleHeadingLevel?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p";
    headingCTA?: { href: string; text?: string; target?: string };
    cards: ILabeledCard[];
    slickerSettings?: Settings;
    linkFunc?: ILinkFunc;
}


export const LabeledImageCardCarousel: React.FC<ILabeledImageCardCarouselProps> = ({
    classNames = "",
    title = "",
    titleHeadingLevel = "h2",
    titleClassNames = "",
    cards,
    headingCTA,
    linkFunc,
    slickerSettings,
}) => {

    const linkf = linkFunc || ((props) => <a {...props} />);

    const LabeledCard = (props: ILabeledCard) => {
        return (
            <BackgroundImage
                key={props.key}
                className={`inverted relative flex flex-col justify-center h-[390px] sm:h-[575px] mx-0.5 items-center ${props.classNames}`}
                src={props.image?.url ?? ""}
            >
                {props.link?.href && linkf({
                    className: `absolute inset-0 flex flex-col justify-center items-center text-composite-text hover:text-composite-text text-4xl font-extralight bg-black/20 hover:bg-black/50`,
                    href: props.link.href,
                    children: props.link.text,
                })}
            </BackgroundImage>
        )
    }

    let titleLayout = "text-center"
    if (headingCTA?.href) {
        titleLayout = "flex flex-row justify-between"
    }

    const carouselCards = cards.map((card) => <LabeledCard {...card} />)

    return (
        <div className={`w-full ${classNames}`}>
            {title && <Heading
                headingLevel={titleHeadingLevel}
                className={`${titleLayout} md:col-span-3 ${titleClassNames}`}
            >
                {title}
                {headingCTA?.href && (
                    <Button
                        linkFunc={linkf}
                        linkProps={{
                            className: "hidden lg:block",
                            href: headingCTA.href,
                            target: headingCTA.target
                        }}
                    >
                        {headingCTA.text}
                    </Button>
                )}
            </Heading>
            }
            <Slider
                className="w-full"
                arrows={false}
                dots={false}
                infinite={true}
                variableWidth={false}
                autoplay={true}
                slidesToShow={5}
                responsive={[
                    {
                        breakpoint: 1023,
                        settings: {
                            slidesToShow: 3,
                            centerMode: true,
                            centerPadding: "32px"
                        }
                    },
                    {
                        breakpoint: 639,
                        settings: {
                            slidesToShow: 1,
                            centerMode: true,
                            centerPadding: "32px"
                        }
                    },
                ]}
                {...slickerSettings}
            >
                {carouselCards}
            </Slider>
            {headingCTA?.href && (
                <div className="w-full flex flex-row justify-end lg:hidden">
                    <Button
                        linkFunc={linkf}
                        linkProps={{
                            href: headingCTA.href,
                            target: headingCTA.target
                        }}
                    >
                        {headingCTA.text}
                    </Button>
                </div>
            )}

        </div>
    )
}

export default LabeledImageCardCarousel

